// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7968c4ba","453":"cf348250"}[chunkId] + ".chunk.js";
};